import React from 'react';
import {Container, Nav, Navbar, Row} from 'react-bootstrap';
import {RiFacebookBoxFill} from 'react-icons/ri'
import {AiFillInstagram} from 'react-icons/ai'
import {FaTwitterSquare} from 'react-icons/fa'
import { MdHelpCenter } from "react-icons/md";
import LogoIcb from '../../images/icb.png'
import manualPDF from '../../doc/Toxifinder_Manual_Usuario.pdf'

export default function Footer() {


  const pdfUrl = process.env.PUBLIC_URL + '/public/Toxifinder_Manual_Usuario.pdf';

  return <div class="foot">
        <Navbar bg="dark" variant="dark" style={{width:'100%'}}>
          <Container style={{}}>
                  <Row style={{alignItems:'center', width:'100%', alignContent: 'center', justifyContent:'center'}}>
                    <div className='col' style={{width:'auto', display:'flex', justifyContent:'center', marginRight:'auto', marginLeft:'auto'}}>
                    <text style={{color:'#fff'}}>Prohibida la reproducción total o parcial de esta obra ©UNIVERSIDAD DE CONCEPCION Registro de Propiedad Intelectual N° 2023-A-12674 año 2023</text>
                    </div>
                    <div className='col' style={{width:'auto', display:'flex', justifyContent:'center', marginRight:'auto', marginLeft:'auto'}}>
                      <img style={{height:'35px',}} src={LogoIcb} alt=""/>
                    </div>
                    <div className='col' style={{width:'auto', display:'flex', justifyContent:'center', marginRight:'auto', marginLeft:'auto'}}>
                      <Nav>
                        {/*
                        <Nav.Link href={manualPDF} target="_blank" rel="noopener noreferrer">
                        <MdHelpCenter style={{fontSize:'20px', color: '#fff' }} />
                        </Nav.Link>
                        */}
                        <Nav.Link href="https://www.facebook.com/toxicologia.farmaciaudec.3">
                        <RiFacebookBoxFill style={{fontSize:'20px', color: '#fff' }} />
                        </Nav.Link>
                        <Nav.Link href="https://www.instagram.com/toxicologiafarmacia/">
                        <AiFillInstagram style={{fontSize:'20px', color: '#fff' }} />
                        </Nav.Link>
                        <Nav.Link href="https://twitter.com/toxicologiafar1">
                        <FaTwitterSquare style={{fontSize:'20px', color: '#fff' }} />
                        </Nav.Link>
                      </Nav>
                    </div>
                  </Row>
          </Container>
        </Navbar>
     </div>
}
